import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "box"
}
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { value: '*' }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = {
  key: 0,
  class: "box"
}
const _hoisted_10 = { class: "subtitle" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_15 = { class: "fermi-json-editor" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_23 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_24 = { key: 6 }
const _hoisted_25 = { class: "columns is-mobile" }
const _hoisted_26 = { class: "column" }
const _hoisted_27 = { class: "column" }
const _hoisted_28 = {
  key: 1,
  class: "box"
}
const _hoisted_29 = { class: "subtitle" }
const _hoisted_30 = { class: "box" }
const _hoisted_31 = { class: "subtitle" }
const _hoisted_32 = { class: "fermi-json-editor" }
const _hoisted_33 = {
  class: "modal-card",
  style: {"width":"600px","max-width":"95vw"}
}
const _hoisted_34 = { class: "modal-card-head" }
const _hoisted_35 = { class: "modal-card-title" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "modal-card-body" }
const _hoisted_38 = { class: "modal-card-foot" }
const _hoisted_39 = {
  key: 0,
  class: "box"
}
const _hoisted_40 = { class: "content has-text-centered" }
const _hoisted_41 = { class: "mb-4 is-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_BFieldHint = _resolveComponent("BFieldHint")!
  const _component_b_select = _resolveComponent("b-select")!
  const _component_b_switch = _resolveComponent("b-switch")!
  const _component_b_taginput = _resolveComponent("b-taginput")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_radio_button = _resolveComponent("b-radio-button")!
  const _component_KeyValueList = _resolveComponent("KeyValueList")!
  const _component_b_tab_item = _resolveComponent("b-tab-item")!
  const _component_JsonEditorVue = _resolveComponent("JsonEditorVue")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_SecretForm = _resolveComponent("SecretForm")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_icon = _resolveComponent("b-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_tabs, {
      modelValue: _ctx.activeMainTab,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.activeMainTab) = $event)),
      class: "mb-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_tab_item, {
          label: _ctx.$t('integrations.webhookBuilder'),
          value: 'form'
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "parameters", {
              parameters: _ctx.form.parameters,
              secrets: _ctx.form.secrets,
              getSecret: _ctx.getSecret,
              setSecret: _ctx.setSecret,
              getParam: _ctx.getParam,
              setParam: _ctx.setParam,
              setParameterValue: (idx, val) => (_ctx.form.parameters[idx].value = val)
            }, () => [
              (_ctx.form.parameters && _ctx.form.parameters.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('integrations.parameters')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.parameters, (param, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "columns is-mobile",
                        key: param.template_name || idx
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_b_field, {
                            label: param.template_name || ('Param ' + (idx + 1))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_input, {
                                modelValue: param.value,
                                "onUpdate:modelValue": ($event: any) => ((param.value) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('integrations.generalSettings')), 1),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('integrations.name'),
                hintKey: _ctx.$t('integrations.nameHelp')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_input, {
                    ref: "nameInput",
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    placeholder: _ctx.$t('integrations.namePlaceholder'),
                    required: "",
                    maxlength: "64",
                    pattern: "[a-Z/_0-9]*",
                    "validation-message": _ctx.$t('integrations.nameValidationError')
                  }, null, 8, ["modelValue", "placeholder", "validation-message"])
                ]),
                _: 1
              }, 8, ["label", "hintKey"]),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('integrations.device'),
                hintKey: "integrations.deviceHelp"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_select, {
                    modelValue: _ctx.form.deviceId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.deviceId) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t('integrations.anyDevice')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceList, (d) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: d.id,
                          value: d.id
                        }, _toDisplayString(d.name || d.id), 9, _hoisted_7))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_BFieldHint, {
                label: _ctx.$t('integrations.status'),
                hintKey: "integrations.statusHelp"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_switch, {
                    modelValue: _ctx.form.enabled,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.enabled) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.enabled ? _ctx.$t('integrations.enabled') : _ctx.$t('integrations.disabled')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              (_ctx.isVisible('secrets'))
                ? (_openBlock(), _createBlock(_component_BFieldHint, {
                    key: 0,
                    label: _ctx.$t('global.secrets'),
                    hintKey: "integrations.secretsHelp"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_taginput, {
                        modelValue: _ctx.selectedSecrets,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSecrets) = $event)),
                        data: _ctx.filteredSecretOptions,
                        autocomplete: "",
                        "open-on-focus": true,
                        "allow-new": false,
                        placeholder: _ctx.$t('secrets.selectSecretsPlaceholder'),
                        type: "is-primary",
                        onTyping: _ctx.onSecretTyping
                      }, null, 8, ["modelValue", "data", "placeholder", "onTyping"]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_b_button, {
                          type: "is-primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.secretModalOpen = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('secrets.addNewButton')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isVisible('requestURL') || _ctx.isVisible('requestType') || _ctx.isVisible('requestFormat'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('integrations.webhookRequest')), 1),
                  (_ctx.isVisible('requestURL'))
                    ? (_openBlock(), _createBlock(_component_b_field, {
                        key: 0,
                        label: _ctx.$t('integrations.url')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_input, {
                            ref: "urlInput",
                            modelValue: _ctx.form.url,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.url) = $event)),
                            required: "",
                            placeholder: _ctx.$t('integrations.urlPlaceholder'),
                            type: "url"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.isVisible('requestType'))
                    ? (_openBlock(), _createBlock(_component_BFieldHint, {
                        key: 1,
                        label: _ctx.$t('integrations.requestType'),
                        hintKey: "integrations.requestTypeHelp"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_select, {
                            modelValue: _ctx.form.requestType,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.requestType) = $event))
                          }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createElementVNode("option", { value: "POST" }, "POST", -1),
                              _createElementVNode("option", { value: "GET" }, "GET", -1),
                              _createElementVNode("option", { value: "PUT" }, "PUT", -1),
                              _createElementVNode("option", { value: "DELETE" }, "DELETE", -1)
                            ]))]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.form.requestType !== 'GET' && _ctx.isVisible('requestFormat'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_BFieldHint, {
                          label: _ctx.$t('integrations.requestFormat'),
                          hintKey: "integrations.requestFormatHelp"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_tabs, {
                              type: "is-toggle",
                              modelValue: _ctx.activeRequestFormatTab,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.activeRequestFormatTab) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_b_tab_item, {
                                  label: _ctx.$t('integrations.requestFormatForm'),
                                  value: 'form',
                                  disabled: _ctx.form.requestType === 'GET' || !_ctx.isVisible('requestFormatForm')
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_BFieldHint, {
                                      label: _ctx.$t('integrations.webForm'),
                                      hintKey: "integrations.webFormHelp"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createVNode(_component_b_field, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_b_radio_button, {
                                                size: "is-small",
                                                modelValue: _ctx.defaultsSelection,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.defaultsSelection) = $event)),
                                                "native-value": "default"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('integrations.default')), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"]),
                                              _createVNode(_component_b_radio_button, {
                                                size: "is-small",
                                                modelValue: _ctx.defaultsSelection,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.defaultsSelection) = $event)),
                                                "native-value": "custom"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('integrations.custom')), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        (!_ctx.form.noDefaults)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                              _createVNode(_component_KeyValueList, {
                                                modelValue: _ctx.defaultFormPairs,
                                                readOnly: true
                                              }, null, 8, ["modelValue"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_KeyValueList, {
                                          modelValue: _ctx.form.formParams,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.formParams) = $event)),
                                          hideHeader: !_ctx.form.noDefaults
                                        }, null, 8, ["modelValue", "hideHeader"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["label", "disabled"]),
                                _createVNode(_component_b_tab_item, {
                                  label: _ctx.$t('integrations.requestFormatJson'),
                                  value: 'json',
                                  disabled: _ctx.form.requestType === 'GET' || !_ctx.isVisible('requestFormatJson')
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_BFieldHint, {
                                      label: _ctx.$t('integrations.jsonBody'),
                                      hintKey: "integrations.jsonBodyHelp"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.isVisible('requestFormatJsonDefault'))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                              _createVNode(_component_b_field, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_b_radio_button, {
                                                    size: "is-small",
                                                    modelValue: _ctx.defaultsSelection,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.defaultsSelection) = $event)),
                                                    "native-value": "default"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.$t('integrations.default')), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"]),
                                                  _createVNode(_component_b_radio_button, {
                                                    size: "is-small",
                                                    modelValue: _ctx.defaultsSelection,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.defaultsSelection) = $event)),
                                                    "native-value": "custom"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.$t('integrations.custom')), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_15, [
                                          (!_ctx.form.noDefaults)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createVNode(_component_JsonEditorVue, {
                                                  modelValue: _ctx.defaultJsonObject,
                                                  mode: _ctx.jsonEditorMode,
                                                  stringified: false,
                                                  "main-menu-bar": false,
                                                  "navigation-bar": false,
                                                  "status-bar": false,
                                                  readOnly: true,
                                                  style: {"height":"320px"}
                                                }, null, 8, ["modelValue", "mode"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _createVNode(_component_JsonEditorVue, {
                                                  modelValue: _ctx.form.jsonData,
                                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.jsonData) = $event)),
                                                  mode: _ctx.jsonEditorMode,
                                                  stringified: false,
                                                  "main-menu-bar": false,
                                                  "navigation-bar": false,
                                                  "status-bar": false,
                                                  style: {"height":"320px"}
                                                }, null, 8, ["modelValue", "mode"])
                                              ]))
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["label", "disabled"]),
                                _createVNode(_component_b_tab_item, {
                                  label: _ctx.$t('integrations.requestFormatCustom'),
                                  value: 'custom',
                                  disabled: _ctx.form.requestType === 'GET' || !_ctx.isVisible('requestFormatCustom')
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_BFieldHint, {
                                      label: _ctx.$t('integrations.customBody'),
                                      hintKey: "integrations.customBodyHelp"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_b_input, {
                                          type: "textarea",
                                          rows: "10",
                                          modelValue: _ctx.form.body,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.body) = $event)),
                                          placeholder: _ctx.$t('integrations.customBodyPlaceholder')
                                        }, null, 8, ["modelValue", "placeholder"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }, 8, ["label", "disabled"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        (_ctx.isVisible('queryParams'))
                          ? (_openBlock(), _createElementBlock("hr", _hoisted_18))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isVisible('queryParams'))
                    ? (_openBlock(), _createBlock(_component_BFieldHint, {
                        key: 3,
                        label: _ctx.$t('integrations.queryParams'),
                        hintKey: "integrations.queryParamsHelp"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.form.requestType === 'GET')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createVNode(_component_b_field, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_b_radio_button, {
                                      size: "is-small",
                                      modelValue: _ctx.defaultsSelection,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.defaultsSelection) = $event)),
                                      "native-value": "default"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('integrations.default')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_b_radio_button, {
                                      size: "is-small",
                                      modelValue: _ctx.defaultsSelection,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.defaultsSelection) = $event)),
                                      "native-value": "custom"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('integrations.custom')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.form.requestType === 'GET' && !_ctx.form.noDefaults)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createVNode(_component_KeyValueList, {
                                  modelValue: _ctx.defaultFormPairs,
                                  readOnly: true
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_KeyValueList, {
                            modelValue: _ctx.form.queryParams,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.queryParams) = $event)),
                            hideHeader: _ctx.form.requestType === 'GET' && !_ctx.form.noDefaults
                          }, null, 8, ["modelValue", "hideHeader"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.isVisible('httpHeaders'))
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_21))
                    : _createCommentVNode("", true),
                  (_ctx.isVisible('httpHeaders'))
                    ? (_openBlock(), _createBlock(_component_BFieldHint, {
                        key: 5,
                        label: _ctx.$t('integrations.httpHeaders'),
                        hintKey: "integrations.httpHeadersHelp"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.form.requestFormat === 'json')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createVNode(_component_KeyValueList, {
                                  modelValue: _ctx.defaultJsonHeaders,
                                  readOnly: true
                                }, null, 8, ["modelValue"])
                              ]))
                            : (_ctx.form.requestFormat === 'form')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createVNode(_component_KeyValueList, {
                                    modelValue: _ctx.defaultFormHeaders,
                                    readOnly: true
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                          _createVNode(_component_KeyValueList, {
                            modelValue: _ctx.form.headers,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.headers) = $event)),
                            hideHeader: _ctx.form.requestFormat === 'json' || _ctx.form.requestFormat === 'form'
                          }, null, 8, ["modelValue", "hideHeader"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.isVisible('httpBasicAuth'))
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_24))
                    : _createCommentVNode("", true),
                  (_ctx.isVisible('httpBasicAuth'))
                    ? (_openBlock(), _createBlock(_component_BFieldHint, {
                        key: 7,
                        label: _ctx.$t('integrations.httpBasicAuth'),
                        hintKey: "integrations.httpBasicAuthHelp"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_b_field, {
                                label: _ctx.$t('integrations.username')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_b_input, {
                                    modelValue: _ctx.form.basicAuth.username,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.basicAuth.username) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_b_field, {
                                label: _ctx.$t('integrations.password')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_b_input, {
                                    type: "password",
                                    "password-reveal": "",
                                    modelValue: _ctx.form.basicAuth.password,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.basicAuth.password) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isVisible('responseTemplate'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("h2", _hoisted_29, _toDisplayString(_ctx.$t('integrations.webhookResponse')), 1),
                  (_ctx.isVisible('responseTemplate'))
                    ? (_openBlock(), _createBlock(_component_BFieldHint, {
                        key: 0,
                        label: _ctx.$t('integrations.responseTemplate'),
                        hintKey: "integrations.responseTemplateHelp"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_input, {
                            type: "textarea",
                            rows: "6",
                            modelValue: _ctx.form.responseTemplate,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.responseTemplate) = $event)),
                            placeholder: _ctx.$t('integrations.responseTemplatePlaceholder')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["label"]),
        (_ctx.isVisible('jsonTab'))
          ? (_openBlock(), _createBlock(_component_b_tab_item, {
              key: 0,
              label: _ctx.$t('integrations.jsonTemplate'),
              value: 'json'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("h2", _hoisted_31, _toDisplayString(_ctx.$t('integrations.integrationJsonRepresentation')), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_JsonEditorVue, {
                      modelValue: _ctx.integrationInitial,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.integrationInitial) = $event)),
                      mode: _ctx.jsonEditorMode,
                      stringified: false,
                      "main-menu-bar": false,
                      "navigation-bar": false,
                      "status-bar": false,
                      style: {"height":"520px"}
                    }, null, 8, ["modelValue", "mode"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["modelValue"]),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.secretModalOpen,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.secretModalOpen) = $event)),
      "has-modal-card": "",
      "trap-focus": "",
      "destroy-on-hide": false,
      "aria-role": "dialog",
      "can-cancel": ['escape','x','outside'],
      "aria-label": "Add Secret",
      "close-button-aria-label": "Close",
      "aria-modal": ""
    }, {
      default: _withCtx((props) => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("header", _hoisted_34, [
            _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('secrets.addNew')), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: props.close
            }, null, 8, _hoisted_36)
          ]),
          _createElementVNode("section", _hoisted_37, [
            _createVNode(_component_SecretForm, {
              rows: 4,
              ref: "secretFormInModal",
              onSaved: _ctx.handleSecretCreated,
              onValid: _cache[24] || (_cache[24] = v => (_ctx.canSaveSecret = v))
            }, null, 8, ["onSaved"])
          ]),
          _createElementVNode("footer", _hoisted_38, [
            _createVNode(_component_b_button, {
              type: "is-primary",
              disabled: !_ctx.canSaveSecret,
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.secretFormInModal?.submit?.()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_b_button, {
              onClick: props.close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('global.close')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (!_ctx.isAdvancedView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t('integrations.missingSomething')), 1),
            _createVNode(_component_b_button, {
              type: "is-info is-outlined",
              onClick: _ctx.toggleView
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_icon, {
                  icon: "cogs",
                  size: "is-small"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('integrations.showAdvancedSettings')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_b_button, {
        type: "is-primary",
        onClick: _ctx.save,
        loading: _ctx.saving,
        disabled: !_ctx.isValid
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading", "disabled"]),
      _createVNode(_component_b_button, {
        class: "ml-2",
        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$router.back()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('global.back')), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}